import { TrevorIcon, TrevorComponent } from '@trevor/ui-components';
import styled from 'styled-components';
import React from 'react';

export const ToggleHint: React.FC<{
  isMinimized: boolean;
  toggle: F<boolean>;
}> = ({ isMinimized, toggle }) => {
  const toggleFunction = () => toggle(!isMinimized);
  const Component = isMinimized ? ClosedState : OpenedState;
  return (
    <div>
      <Component onClick={toggleFunction} />
    </div>
  );
};

const OpenedStateRaw: TrevorComponent<{ onClick: F0 }> = ({
  className,
  onClick,
}) => {
  return (
    <div onClick={onClick} className={className}>
      <span>&#10005;</span>
    </div>
  );
};

const ClosedStateRaw: TrevorComponent<{ onClick: F0 }> = ({
  onClick,
  className,
}) => {
  return (
    <div className={className} onClick={onClick}>
      <div>
        <TrevorIcon name="question" width={16} height={17} />
      </div>
      Start customizing
    </div>
  );
};

const OpenedState = styled(OpenedStateRaw)`
  display: inline-flex;
  border: 1px solid #ddd;
  background: #fff;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  height: 42px;
  padding: 0 12px;
  border-radius: 23px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  margin-top: 8px;

  span {
    font-size: 18px;
  }
`;

const ClosedState = styled(ClosedStateRaw)`
  display: inline-flex;
  background: #061e2d;
  border-radius: 34px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  height: 33px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-top: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  color: #ffffff;
  width: 181px;
  gap: 12px;

  svg {
    width: 16px;
    height: 16px;
  }
`;
